import { createRoot, createSignal } from 'solid-js';

export interface Toast {
  id: number;
  message: string;
  tone: 'info' | 'ok' | 'warn' | 'bad';
  action?: { label: string; href?: string; run?: () => void };
}

const store = createRoot(() => {
  const [toasts, setToasts] = createSignal<Toast[]>([]);
  return { toasts, setToasts };
});

let seq = 0;
export const toasts = store.toasts;

export function toast(message: string, opts: { tone?: Toast['tone']; action?: Toast['action']; ms?: number } = {}): void {
  const id = ++seq;
  store.setToasts((t) => [...t.slice(-3), { id, message, tone: opts.tone ?? 'info', action: opts.action }]);
  setTimeout(() => dismiss(id), opts.ms ?? (opts.tone === 'bad' ? 8000 : 5000));
}

export function dismiss(id: number): void {
  store.setToasts((t) => t.filter((x) => x.id !== id));
}
